import { render, staticRenderFns } from "./GeneralResolution.vue?vue&type=template&id=1a86993d&scoped=true&"
import script from "./GeneralResolution.vue?vue&type=script&lang=js&"
export * from "./GeneralResolution.vue?vue&type=script&lang=js&"
import style0 from "./GeneralResolution.vue?vue&type=style&index=0&id=1a86993d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86993d",
  null
  
)

export default component.exports